import React from "react"
import Typewriter from "typewriter-effect"
import { navigate } from "gatsby-link"
import "../styles/contact.scss"
import Sending from "./Sending"

interface ContactProps {
  close?: () => void
}

interface ContactFormState {
  [key: string]: string
}

const Contact: React.FC<ContactProps> = ({ close }) => {
  const [state, setState] = React.useState<ContactFormState>({})
  const [messageSending, setMessageSending] = React.useState<boolean>(false)

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setMessageSending(true)
    const url = `/.netlify/functions/contact`
    fetch(url, {
      method: "POST",
      body: JSON.stringify(state),
    })
      .then(response => {
        response.ok ? navigate("/success") : navigate("/success")
        setMessageSending(false)
      })
      .then(() => {
        if (typeof close === "function") close()
      })
  }

  return (
    <div className="contactContainer">
      <div style={{ margin: "auto", minWidth: "100%" }}>
        <h1 className="contactH1">
          <Typewriter
            onInit={typewriter => {
              typewriter
                .typeString("Contact me")
                .start()
                .callFunction(function (state: any) {
                  state.elements.cursor.style.display = "none"
                })
            }}
          />
        </h1>
        <form
          name="contact"
          method="post"
          action="/contact-us"
          onSubmit={handleSubmit}
        >
          <p hidden>
            <label>
              Don’t fill this out:{" "}
              <input name="bot-field" onChange={handleChange} />
            </label>
          </p>
          <input type="hidden" name="form-name" value="contact" />
          <label htmlFor="name">Your Name</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            placeholder="Name"
            onChange={handleChange}
          />
          <label htmlFor="email">Your Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="E-Mail adress"
            onChange={handleChange}
          />
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            required
            placeholder="Your message"
            rows={3}
            onChange={handleChange}
          />
          {messageSending ? (
            <button type="submit" disabled={messageSending}>
              <Sending />
            </button>
          ) : (
            <button type="submit" disabled={messageSending}>
              Send
            </button>
          )}
        </form>
      </div>
    </div>
  )
}

export default Contact
